import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { translate } from 'react-i18next';
import observeRootStore from '../../components/hoc/observeRootStore';
import CardItem from './cardItem';
import * as constants from '../../appConstants';

import './card.scss';
const CARD_ID = 'card';
const DEFAULT_OFFSET = 200;

export class Card extends Component {
    constructor() {
        super();

        this.state = {
            carouselSettings: {
                arrows: false,
                autoplay: true,
                autoplaySpeed: 2500,
                className: 'card-carousel',
                dots: false,
                fade: false,
                infinite: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                speed: 300,
            }
        };
    }

    positionCard = () => {
        const { rootStore } = this.props;
        const stateObj = rootStore.uiStore.selectedState;
        const statePositionData = document
            .getElementById(stateObj.gid)
            .getBoundingClientRect();
        return {
            top: this.getTopPosition(statePositionData),
            left: statePositionData.left + statePositionData.width / 2
        };
    };

    getTopPosition = statePositionData => {
        if (this.displayUnderState()) {
            return statePositionData.bottom;
        } else {
            return statePositionData.top - DEFAULT_OFFSET;
        }
    };

    displayUnderState = () => {
        return (
            document
                .getElementById(this.props.rootStore.uiStore.selectedState.gid)
                .getBoundingClientRect().top -
                DEFAULT_OFFSET < 0
        );
    };

    isSlideFiltered = filter => {
        const selectedFilter = this.props.rootStore.uiStore.selectedFilter;
        return (
            selectedFilter === constants.FILTER_ALL ||
            selectedFilter === filter
        );
    };

    hasDealers = stateObj => {
        const selectedFilter = this.props.rootStore.uiStore.selectedFilter;
        if (stateObj.dealersCoordinates.length > 0) {
            return true;
        } else {
            return (stateObj.classList.indexOf(selectedFilter) > 0);
        }
    };

    shouldDisplayState = stateObj => {
        const selectedFilter = this.props.rootStore.uiStore.selectedFilter;
        let filtered = false;
        if (selectedFilter !== constants.FILTER_ALL) {
            if (selectedFilter === constants.FILTER_DEALERSHIPS) {
                filtered = !this.hasDealers(stateObj);
            } else {
                filtered = (stateObj.classList.indexOf(selectedFilter) < 0);
            }
        }
        return filtered;
    };

    renderSlides = () => {
        const { t, rootStore } = this.props;
        const stateObj = rootStore.uiStore.selectedState;
        const slidesArr = [{
                value: stateObj.manufacturingDistribution,
                label: t('filters.engMan'),
                notFiltered: this.isSlideFiltered(constants.FILTER_ENG_MAN)
            }, {
                value: stateObj.researchDesign,
                label: t('filters.researchDev'),
                notFiltered: this.isSlideFiltered(constants.FILTER_RESEARCH_DEV)
            }, {
                value: stateObj.dealers,
                label: t('filters.dealerships', { count: stateObj.dealers }),
                notFiltered: this.isSlideFiltered(constants.FILTER_DEALERSHIPS)
            }, {
                value: stateObj.corporateOffices,
                label: t('filters.offices', { count: stateObj.corporateOffices }),
                notFiltered: this.isSlideFiltered(constants.FILTER_OFFICES)
            }].filter(obj => (obj.value > 0) && obj.notFiltered);

        return slidesArr.map((obj) =>
                <CardItem key={`slide-${obj.value}`} label={obj.label} value={obj.value} />
            );
    }

    render() {
        const { rootStore } = this.props;
        const uiStore = rootStore.uiStore;
        const stateObj = uiStore.selectedState;
        const underClass = this.displayUnderState() ? 'underState' : '';
        const hasCardContent = !this.shouldDisplayState(stateObj);

        if (hasCardContent) {
            return (
                <div
                    id={CARD_ID}
                    className={`${underClass} card`}
                    style={this.positionCard()}
                >
                    <div className="card-body">
                        <h1>{stateObj.state}</h1>
                        <Slider {...this.state.carouselSettings}>
                            {this.renderSlides()}
                        </Slider>
                    </div>
                    <div className="card-arrow" />
                </div>
            );
        } else {
            return null;
        }
    }
}

Card.propTypes = {
    rootStore: PropTypes.shape({
        uiStore: PropTypes.shape({
            selectedState: PropTypes.shape({
                gid: PropTypes.string.isRequired,
                state: PropTypes.string.isRequired,
                manufacturingDistribution: PropTypes.number,
                researchDesign: PropTypes.number,
                dealers: PropTypes.number,
                corporateOffices: PropTypes.number,
                dealersCoordinates: PropTypes.arrayOf(PropTypes.object),
                classList: PropTypes.arrayOf(PropTypes.string),
            }).isRequired,
            selectedFilter: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    t: PropTypes.func.isRequired,
};

export default translate()(observeRootStore(Card));
